module.exports = __webpack_public_path__ + "static/media/iPhoneX2.ee3f59dc.png";